import React, { FC } from "react";
import { useParams } from "react-router-dom";

import { useGetWorkActivityQuery } from "../../../../slices/ActivityLogSlice";
import { ActivityLogList } from "../../../activityLog/ActivityLogList";

/** The work item's "Log" tab: everything that happened to this work item. */
export const WorkLog: FC = () => {
  const { workId } = useParams();
  const { data, isLoading, isError } = useGetWorkActivityQuery(
    { workId: workId || "" },
    { skip: !workId, refetchOnMountOrArgChange: true },
  );

  return (
    <div className={"max-w-[760px] pb-6"}>
      {isLoading && (
        <div className={"py-10 text-center text-[14px] text-[#9097A8]"}>
          Loading…
        </div>
      )}
      {isError && (
        <div
          className={
            "rounded-[13px] border border-[#E8E8EC] bg-white p-12 text-center text-[14px] text-[#9097A8]"
          }>
          The log couldn’t be loaded. Please try again.
        </div>
      )}
      {!isLoading && !isError && (data?.length ?? 0) === 0 && (
        <div
          className={
            "rounded-[13px] border border-[#E8E8EC] bg-white p-12 text-center text-[14px] text-[#9097A8]"
          }>
          No activity recorded for this work item yet.
        </div>
      )}
      {!!data?.length && <ActivityLogList entries={data} inWork />}
    </div>
  );
};
